/* MSE Kontakt-Banner (A1): Auf- und Zuklappen wie bisher in mse-hero-banner.
   Zusaetzlich: solange der Warenkorb (cart-drawer.active) offen ist, bekommt
   <body> die Klasse mse-cart-open (Rueckfall fuer Browser ohne :has()). */
(function () {
  var badge = document.querySelector('[data-mse-sidebadge][data-section-id="global"]');
  if (!badge) return;
  var btn = badge.querySelector('.mse-sidebadge__toggle');

  function close() {
    badge.classList.remove('is-open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  if (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = !badge.classList.contains('is-open');
      badge.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    if (!badge.contains(e.target)) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && badge.classList.contains('is-open')) {
      close();
      if (btn) btn.focus();
    }
  });

  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    var sync = function () {
      var offen = drawer.classList.contains('active');
      document.body.classList.toggle('mse-cart-open', offen);
      if (offen) close();
    };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
})();
